const indexConstants = {
    ROOT: "root",
    I18N: 'i18nextLng',
    SPANISH: "es",
}

export default indexConstants;